import React from 'react'

const Flexbox_Coding_Pratice_7 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 7</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_7
